// Layer 4 (UI): Quality › Impurities smelter-penalty panel (paul-fmea.A15 /
// #280), rebuilt to the locked comp `.impeccable/mocks/decision/quality.html`
// A (polish.P10 #658): one hairline table per concentrate group with the
// assay, an assay ÷ limit headroom bar, the contract limit and one state chip.
// The row's provenance (contract, typical trigger, measurement) is the hover
// title on the element — no per-row chip. All projection lives in the
// transform sibling; the Metallurgist's concentrate read keeps its own row
// (`shared/PenaltyElementRow.tsx`) over the same model.
// See docs/logic/quality/concentrate-spec.md.

import { Fragment } from 'react';
import { Table, TBody, TD, TH, THead, TR } from '@/design-system';
import { cn } from '@/shared/cn';
import { provenanceTitle } from '@/versions/v1/shared/PenaltyElementRow';
import { CARD_TABLE_DENSE, DowntimeCard, RankBar } from '../downtime/DowntimeCard';
import { concentratePenaltyPanelModel } from './ConcentratePenaltyPanel.transform';
import { StateChipPill } from './QualityUi';

export function ConcentratePenaltyPanel({ className }: { className?: string }) {
  const model = concentratePenaltyPanelModel();

  return (
    <DowntimeCard title="Smelter contract limits · penalty elements" meta="bar = assay ÷ limit" className={className}>
      <div className={CARD_TABLE_DENSE} data-penalty-table>
        <Table wrap={false} className="tabular-nums">
          <THead>
            <TR>
              <TH>Element</TH>
              <TH className="text-right">Assay</TH>
              <TH className="w-[30%]">Of limit</TH>
              <TH className="text-right">Limit</TH>
              <TH className="text-right"><span className="sr-only">State</span></TH>
            </TR>
          </THead>
          <TBody>
            {model.groups.map((group) => (
              <Fragment key={group.id}>
                <TR>
                  <TD colSpan={5} className="!pb-1 !pt-2.5 text-xs font-semibold uppercase tracking-[0.07em] !text-muted">
                    {group.label}
                  </TD>
                </TR>
                {group.rows.map((row) => (
                  <TR key={`${group.id}-${row.element}`} data-penalty-row={`${group.id}-${row.element}`}>
                    <TD className="whitespace-nowrap">
                      <span title={provenanceTitle(row)} className="cursor-help font-mono text-xs font-medium text-ink-primary">
                        {row.element}
                      </span>
                    </TD>
                    <TD className="whitespace-nowrap text-right font-semibold !text-ink-primary">{row.currentText ?? '—'}</TD>
                    <TD>
                      {row.limitRatio !== undefined ? (
                        <RankBar ratio={row.limitRatio} tone={row.tone === 'warn' ? 'warn' : row.tone === 'bad' ? 'bad' : 'ink'} />
                      ) : null}
                    </TD>
                    <TD className="whitespace-nowrap text-right">{row.contractLimitText ?? '—'}</TD>
                    <TD className={cn('whitespace-nowrap text-right')}>
                      <StateChipPill tone={row.tone}>{row.statusLabel}</StateChipPill>
                    </TD>
                  </TR>
                ))}
              </Fragment>
            ))}
          </TBody>
        </Table>
      </div>
    </DowntimeCard>
  );
}
